import { DateTime } from "kea-react";
import { SolucionEnrutamiento } from "./enrutamiento";
import { StatusCajaRutaViewDto } from "./statuscajaruta";
/**Indica si un movimientode carga/descarga es de carga o de descarga */
export enum TipoCargaDescarga {
    Carga,
    Descarga
}

/**Indica si una carga/descarga esta en proceso de subir/bajar guias o si ya terminó */
export enum StatusCargaDescarga {
    /**La carga/descarga esta en proceso de subir/bajar guias */
    EnProceso,
    /**Cancela el proceso de carga, esto solo se puede hacer si la carga esta en proceso y si aún no se le han metido guias a la caja o paquetes */
    Cancelado,
    /**Ya termino la carga/descarga */
    Terminado
}

/**Agrupa todas las guias que fueron cargadas o descargadas a una caja, el reporte de manifiesto de carga es extraído de este registro */
export interface CargaDescargaCajaRuta {
    IdRegistro: number;

    /**Id de la caja en la que se esta cargando o descargando */
    IdCajaRuta: number;

    /**Indica si es de carga o de descarga */
    Tipo: TipoCargaDescarga;

    /**Status de la carga/descarga. Este valor es informativo y no afecta a los status de las guias */
    Status: StatusCargaDescarga;

    /**Fecha en la que inició el proceso. */
    FechaInicio: Date | string;

    /**
     * Fecha en la que finalizó el proceso. Un CHECK verifica que no sea null si Status == Terminado.
     * Esta fecha no afecta en ninguna forma al status de las guias, ya que cada movimiento individual por guia tiene la fecha
     * TODO: Agregar el CHECK
     */
    FechaTermino: Date | string | null;

    /**Folio único */
    Folio: number;

    /**Guias que son incluidas en esta carga o descarga */
    Guias: MovimientoGuiaCargaDescargaRuta[];
}

/**
 * Un movimiento de carga/descarga. Es detalle de @see CargaDescargaCajaRuta 
 */
export interface MovimientoGuiaCargaDescargaRuta {
    /**Llave primaria */
    IdRegistro: number;

    /**Id de la carga/descarga */
    IdCargaDescargaCajaRuta: number;
    CargaDescargaCajaRuta: CargaDescargaCajaRuta;

    /**Id de la guía */
    IdGuia: number;

    /**Fecha real de la carga de esta guia */
    Fecha: Date | string;
}

export interface CargaDescargaCajaRutaDto extends CargaDescargaCajaRuta {
    NombreCaja: string;

    /**Nombre del chofer responsable de esta carga/descarga */
    NombreChofer: string;

    /**Si el proceso de carga/descarga tiene algun paquete, sobre o guia ya cargado o descargad */
    TieneServiciosArriba: boolean;
    /**Si el proceso de carga/descarga tiene algunos paquetes o sobres que no acompleten la guia */
    TieneGuiasIncompletas: boolean;

    /**Cantidad de guias de la carga */
    CantidadGuias: number;

    NombreSucursal: string;
    NombreRuta: string;
    NombreCamionAsignado: string;
}

export interface ManifiestosCargaDescargaRADView
{
    IdRegistro: number;
    Fecha: DateTime;
    Tipo: string;
    FolioCargaDescarga: string;
    NombreCaja: string;
    NombreCamion: string;
    FolioGuia: string;
    SucursalOrigen: string;
    SucursalDestino: string;
    Peso: number;
    ValorDeclarado: number|null;
    cantidad: number;
    Largo: number;
    Alto: number;
    Ancho: number;
    Contenido: string;
    Descripcion: string;
}

/**Indica si las guias de cierto destino se deben o no de cargar/descargar a la caja */
export enum OpcionCargarDescargar {
    /**La carga o descarga no se debe de realizar ya que no hay ninguna ruta posible que implique cargar o descargar las guias con este destino */
    No,
    /**La carga o descarga se debe de realizar ya que todas las rutas posibles indican que se debe de cargar o descargar las guias con este destino */
    Si,
    /**La carga o descarga es opcional ya que hay algunas rutas posibles que implicar cargar o descargar la guia y otras que implican no hacerlo */
    Opcional
}

/**Uno de los destino de carga o descarga */
export interface DestinoCargaDescarga {
    /**Sucursal de destino */
    IdSucursalDestino: number;

    /**Nombre de la sucursal destino */
    NombreSucursalDestino: string;

    /**Indica si se debe o no realizar la carga/descarga */
    Opcion: OpcionCargarDescargar;

    /**Todas las rutas posibles para llegar al destino */
    RutasPosibles: SolucionEnrutamiento[];

    /**Cantidad de guias en la sucursal que van para este destino */
    CantidadGuias: number;

    /**Id del a ruta asignada al camión al que la caja esta conectada */
    IdRutaCaja: number;
}


export interface CargaDescargaFiltro {
    Status: StatusCargaDescarga | null;
    Tipo: TipoCargaDescarga | null;

    FechaInicioInicio: Date | string | null;
    FechaInicioFinal: Date | string | null;

    FechaTerminoInicio: Date | string | null;
    FechaTerminoFinal: Date | string | null;

    IdCajaRuta: number | null;

    Limite: number | null;

}

export interface ManifiestosCargaDescargaFiltro{
        FechaInicio: Date | null;
        FechaFin: Date | null;
}

/**DTO de un paquete pendiente en una carga/descarga */
export interface PaquetePendienteDto {
    IdServicio: number;
    NumeroFisico: number;

    IdGuia: number;
    FolioGuia: string;
    /**Camtidad total de servicios de este tipo en la guia */
    CantidadTotal: number;

    Descripcion: string;
    Contenido: string;

    /**Peso en KG. Solo aplica para los paquetes */
    Peso: number;
    /**Largo en CM. Sólo aplica para los paquetes */
    Largo: number;

    /**Alto en CM. Sólo aplica para los paquetes */
    Alto: number;

    /**Ancho en CM. Sólo aplica para los paquetes */
    Ancho: number;

    /**Peso volumetrico del paquete */
    PesoVolumetrico: number;

    /**Valor declarado del paquete en caso de que se quiera asegurar el mismo */
    ValorDeclarado: number | null;
}

/**DTO de un sobre pendiente */
export interface SobrePendienteDto {
    IdServicio: number;
    NumeroFisico: number;

    IdGuia: number;
    FolioGuia: string;
    /**Camtidad total de servicios de este tipo en la guia */
    CantidadTotal: number;

    Contenido: string;
}

/**DTO del status de una carga/descarga */
export interface PendientesCargaDescarga {
    PaquetesPendientes: PaquetePendienteDto[];
    SobresPendientes: SobrePendienteDto[];
}

/**Resumen de una carga/descarga */
export interface ResumenCargaDescarga {
    /**Cantidad total de paquetes/sobres que estan incluidos pero que aun no acompletan la guia */
    CantidadServiciosIncompletos: number;

    /**Cantidad total de paquetes incluidos */
    CantidadPaquetes: number;

    /**Cantidad total de sobres incluidos */
    CantidadSobres: number;

    /**Cantidad de guias incluidas */
    CantidadGuias: number;
}

export enum TipoFolioFisico {
    Paquete,
    Sobre
}

/**El resultado de leer un folio de un paquete o sobre fisico */
export interface LecturaFolioFisico {
    /**Folio de la guia */
    FolioGuia: string;
    /**Si es paquete o sobre */
    Tipo: TipoFolioFisico;

    /**Numero fisico del paquete o sobre */
    NumeroFisico: number;

    /**Cantidad total de servicios fisicos en esta huia */
    TotalNumerosFisicos: number;

    /**Id de la guia */
    IdGuia: number;

    /**Id del paquete o sobre */
    IdPaqueteSobre: number;
}

/**Almacena la ultima lectura de un folio fisico*/
export interface UltimaLecturaFolioFisico {
    lectura: LecturaFolioFisico;
    idCargaDescarga: number;
}

export interface InicioCargaDescarga {
    IdCajaRuta: number;
    IdChofer: number;
    Tipo: TipoCargaDescarga;
}

/**Si una carga o descarga se hizo escribiendo el código o escaneando el QR */
export enum MetodoCargaDescarga {
    QR = 0,
    Manual = 1,
}



// WEBPACK FOOTER //
// ./app/models/cargadescarga.ts